module.exports = __webpack_public_path__ + "media/fr_fr_s3_Sinclaire.339b0816.mp3";